export default __webpack_public_path__ + "static/media/starFilled.a9db3c31.svg";